// extracted by mini-css-extract-plugin
export var actuItem = "listActus-module--actu-item--5b885";
export var actuItemsContainer = "listActus-module--actu-items-container--23a8d";
export var actuTaxoContainer = "listActus-module--actu-taxo-container--ae335";
export var actualiteCategorie = "listActus-module--actualite-categorie--2c607";
export var actualiteDate = "listActus-module--actualite-date--63eec";
export var actualiteInfos = "listActus-module--actualite-infos--c6f14";
export var actualiteResume = "listActus-module--actualite-resume--32281";
export var actualiteTitle = "listActus-module--actualite-title--80a05";
export var actusFilters = "listActus-module--actus-filters--f9d9f";
export var disabled = "listActus-module--disabled--f9d33";
export var listActualitesContainer = "listActus-module--list-actualites-container--345d7";
export var listActus = "listActus-module--list-actus--714a3";
export var vocalizedUpdate = "listActus-module--vocalized-update--f67b0";
export var zoneActualitesLibreBas = "listActus-module--zone-actualites-libre-bas--72e15";
export var zoneActualitesLibreHaut = "listActus-module--zone-actualites-libre-haut--4dc5e";